import Cookies from "js-cookie";

(function ($) {
  "use strict";
  $(function () {

    let birthDayPopup = $('#birthday-popup');
    if (birthDayPopup.length) {
      birthDayPopup.foundation('open');
      birthDayPopup.on('closed.zf.reveal', function () {
        let date = new Date();
        date.setDate(date.getDate() + 1);
        date.setHours(0, 0, 0);
        Cookies.set('birthday-popup', 'N', {expires: date});
      })
    }


    /** Попап с временем работы филиала для корзины*/
    let pickUpBranchWorkingTime = $('#pickupBranchWorkingTime')
    if (pickUpBranchWorkingTime.length !== 0) {
      pickUpBranchWorkingTime.foundation('open');
    }

    $(document).on('click', '.integral__tip', function (e) {
      let tooltip = $(this);
      if (tooltip.length) {
        e.preventDefault();
        e.stopPropagation();
        tooltip.foundation('show');
      }
    })

    let $workingTimePopup = $('#orderStartModal');
    if ($workingTimePopup.length) {
      $workingTimePopup.foundation('open');
    }

    $(document).on('click', '.js-discount-first-order', function (e) {
      Cookies.set('discount-first-order', 'Y');
    })
  })
})(jQuery);
